import React from "react";
import { useForm } from "react-hook-form";
import "./auth.css";
import {
  useForgetPasswordMutation,
  useLoginMutation,
} from "../../store/api/authApi";
import { setCredentials } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";
import InlineMessageComponent from "../../components/common/InlineMessageComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import styles from "./ForgetPassword.module.css";
import BannerHeader from "../../components/BannerHeader/BannerHeader";

const ForgetPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const dispatch = useDispatch();
  const [
    getForgetPasswordEmail,
    {
      isLoading: forgetLiskInPrigress,
      data: forgetData,
      error: errorInLinkSend,
    },
  ] = useForgetPasswordMutation();
  const handleLogin = async (formData) => {
    try {
      const response = await getForgetPasswordEmail(formData).unwrap();
      if (!response?.isError) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Reset failed:", err);
    }
  };
  return (
    <>
      <BannerHeader />
      <div className={`${styles.mainContainer} container`}>
        <section className={styles.content}>
          <div className={styles.forgetPasswordHeader}>
            <h1 className="heading">Forget Password?</h1>
            <p className="subheading">
              Please enter your email to reset your password.
            </p>
          </div>
          <div
            className={
              styles.forgetPasswordBox + " login-registration-container"
            }
          >
            <InlineMessageComponent
              type={"error"}
              message={errorInLinkSend?.data?.message}
            />
            <form
              onSubmit={handleSubmit(handleLogin)}
              className="signup-login-form"
            >
              <div className="form-group">
                <label>Email*</label>
                <input
                  className={`form-input ${errors.email ? "error" : ""}`}
                  type="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                />
                {errors.email && (
                  <span className="error-message">{errors.email.message}</span>
                )}
              </div>

              <button type="submit" className="submit-button">
                Get Reset Link{" "}
                {forgetLiskInPrigress && <InlineLoaderComponent />}
              </button>
            </form>
          </div>
        </section>
      </div>
    </>
  );
};

export default ForgetPassword;
